import useLocalizedNavigate from 'hooks/useLocalizedNavigate';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const useGoBack = (fallback?: string) => {
  const navigate = useLocalizedNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.key === 'default' && fallback) {
      navigate(fallback, { replace: true });
    } else {
      navigate(-1);
    }
  }, [navigate, location.key, fallback]);
};

export default useGoBack;
